module.exports = __webpack_public_path__ + "media/images/athletes/3309-ccfaaafd26d442f11ec50b86b5f2595e.png";